import { render, staticRenderFns } from "./ListInitialTable.vue?vue&type=template&id=b8d217e4&scoped=true"
import script from "./ListInitialTable.vue?vue&type=script&lang=js"
export * from "./ListInitialTable.vue?vue&type=script&lang=js"
import style0 from "./ListInitialTable.vue?vue&type=style&index=0&id=b8d217e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d217e4",
  null
  
)

export default component.exports